import 'isomorphic-fetch'
import { logError, GVSAPICallError } from 'utils/datadog'

export default ({ dispatch, getState }) => next => action => {
  if (!action.types) {
    // Normal action: pass it on
    return next(action)
  }
  
  if (!action.url || !action.method) return

  const [requestType, successType, failureType] = action.types
  
  dispatch({ type: requestType, payload: action.body })

  return Promise.resolve()
    .then(constructFetch(action, getState))
    .then(responseToJson)
    .then(responseObject => {
      const response = responseObject.body
      const failed = responseObject.status >= 400

      if (failed) {
        logError(new GVSAPICallError(action.url, action.method, responseObject.status, response), {
          appointmentId: getState().visit.appointmentId,
          conferenceId: getState().visit.conferenceId,
          requestBody: action.body ? action.body : {},
          responseBody: response
        })
        dispatch({ type: failureType, status: responseObject.status, error: response.error, errorDetails: response.error_detail })
        action.onFailure && action.onFailure(responseObject.status, response.error)
      } else {
        dispatch({ type: successType, response: response })
        action.onSuccess && action.onSuccess(response)
      }
      return response
    })
}

function getDefaultHeaders () {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
}

function getTokenHeaders (action, getState) {
  const tokenHeaders = {}
  const jwtToken = getState().visit.jwtToken || action.jwt
  if (jwtToken) tokenHeaders['JWT'] = jwtToken
  const userToken = getState().visit.userToken
  if (userToken) tokenHeaders['TOKEN'] = userToken
  if (action.basicAuth) tokenHeaders['Authorization'] = `Basic ${action.basicAuth}`
  return tokenHeaders
}

function constructFetch (action, getState) {
  const {
    url
  } = action

  const fetchOptions = {
    method: action.method,
    headers: {
      ...getDefaultHeaders(),
      ...getTokenHeaders(action, getState)
    }
  }

  if (action.method !== 'GET' && action.body) {
    fetchOptions.body = JSON.stringify(action.body)
  }

  return function () {
    return fetch(url, fetchOptions)
  }
}

function responseToJson (response) {
  return new Promise(resolve => {
    const contentType = response.headers.get('content-type')
    const responseObject = {
      url: response.url,
      status: response.status,
      headers: response.headers,
      statusText: response.statusText
    }

    const isJson = contentType && contentType.indexOf('json') > -1
    response.text().then(text => {
      return text && isJson ? JSON.parse(text) : text
    }).then(body => {
      return resolve({...responseObject, body, type: isJson ? 'json' : 'text'})
    })
  })
}


